import { defineMessages, useIntl } from 'react-intl';

import { UNKNOWN_UNIT, formatUnitLabel } from '@constants/medication-dosage';

const messages = defineMessages({
  /** Stands in for the dose form when the record doesn't name one. */
  genericForm: { id: 'medicationForm.genericForm', defaultMessage: 'dose' },
  genericFormPlural: {
    id: 'medicationForm.genericFormPlural',
    defaultMessage: 'doses',
  },
});

/**
 * The noun the medication form reads in: "each **tablet** contains", "takes 2
 * **tablets**". Comes from the Form dropdown, which is the only place it is
 * chosen now.
 *
 * Form is optional and can be set to "Unknown", so the sentences need something
 * to fall back on. "Dose" is deliberately vague — it keeps the line grammatical
 * without asserting a form nobody recorded.
 */
export function useDoseFormNoun() {
  const { formatMessage } = useIntl();
  return (doseForm: string, count: number) => {
    if (!doseForm || doseForm === UNKNOWN_UNIT) {
      return formatMessage(
        count === 1 ? messages.genericForm : messages.genericFormPlural
      );
    }
    return formatUnitLabel(doseForm, count);
  };
}
